module.exports = __webpack_public_path__ + "img/flicker_blue2.1a2adefc.gif";